import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import build from "redux-object";
import { Button, Header, Icon, Modal, Label } from "semantic-ui-react";
import { get, isEmpty } from "lodash";

import { fetchDeleteSummary, deleteRecord } from "../../actions/delete.actions";
import { expirePurchase } from "../../actions/purchases.actions";

export class DeleteModal extends Component {
  state = {
    disableDeleteAction: true,
    modalOpen: false,
    recordSlug: "",
    recordName: "",
    resourceName: "",
    message: "",
    expirePurchases: false
  };

  static getDerivedStateFromProps(nextProps, state) {
    return {
      ...state,
      recordSlug: nextProps.recordSlug,
      recordName: nextProps.recordName,
      resourceName: nextProps.resourceName
    };
  }

  handleOpen = () => {
    const { resourceName, recordSlug } = this.state;

    this.props.dispatch(fetchDeleteSummary(resourceName, recordSlug)).then(() => {
      this.handleMessage(this.props.resource);
    });

    this.setState({ modalOpen: true, disableDeleteAction: true });
  };

  confirmDelete = () => {
    const { resourceName, recordSlug } = this.state;

    this.props.dispatch(deleteRecord(resourceName, recordSlug));

    this.setState({ modalOpen: false });
  };

  handleCancel = () => this.setState({ message: "", modalOpen: false, disableDeleteAction: true });

  expirePurchase = resource => {
    this.props.dispatch(expirePurchase(resource.id));

    this.setState({ modalOpen: false });
  };

  handleMessage = resource => {
    const { resourceName } = this.state;

    if (resource) {
      switch (resourceName) {
        case "customers":
          if (!isEmpty(resource.ownedPurchases) || !isEmpty(resource.assignedPurchases)) {
            return this.setState({
              message: "This customer has Purchases/Invoices assigned. Delete those records and then try again."
            });
          } else {
            return this.setState({
              message:
                "If you proceed, the customer will be deleted from Purchase Engine. Are you sure you want to continue?",
              disableDeleteAction: false
            });
          }
        case "customerGroups":
          if (!isEmpty(resource.discounts)) {
            return this.setState({
              message: "There are discounts assigned to this customer group. Delete those first."
            });
          } else if (!isEmpty(resource.customerGroupings)) {
            return this.setState({
              message: "This customer group has Customers assigned. Remove their grouping first."
            });
          } else {
            return this.setState({
              message:
                "If you proceed, the customer group will be deleted from Purchase Engine. Are you sure you want to continue?",
              disableDeleteAction: false
            });
          }
        case "products":
          if (!isEmpty(resource.purchases)) {
            return this.setState({
              message:
                "There are purchases that contain this subscription. Delete those records first, if you want to continue."
            });
          } else {
            return this.setState({
              message: "If you continue, the subscription will be deleted only from Purchase Engine.",
              disableDeleteAction: false
            });
          }
        case "purchases":
          const productBundles = get(resource, "product.productBundles", []);
          const bundleUsages = productBundles.find(item => item.bundleUsages.length > 0);
          if (!isEmpty(resource.invoices)) {
            return this.setState({
              message: "There are invoices that contain this purchase. Delete those records first, if you want to continue."
            });
          } else if (resource.links?.expirePurchases) {
            return this.setState({
              message:
                "The purchase can't be deleted cause it's attached to a processed invoice. Do you want to expire the purchase immediately? If you continue, the customer will not be able to use this purchase anymore!",
              disableDeleteAction: false,
              expirePurchases: true
            });
          } else if (!isEmpty(bundleUsages)) {
            return this.setState({
              message:
                "Deleting this purchase will also clean the assignment of the subscription bundles and this customer.",
              disableDeleteAction: false
            });
          } else {
            return this.setState({
              message:
                "If you proceed, the purchase will be deleted from Purchase Engine. Are you sure you want to continue? If yes, enter the purchase number you want to delete.",
              disableDeleteAction: false
            });
          }
        case "outOfBundlePurchases":
          return this.setState({
            message: "If you proceed, the purchase will be deleted from Purchase Engine. Are you sure you want to continue?",
            disableDeleteAction: false
          });
        case "bundles":
          if (!isEmpty(resource.productBundles) || !isEmpty(resource.templatesBundles)) {
            return this.setState({
              message:
                "There are templates / subscriptions / purchases / invoices that contain this bundle. Delete those records first, if you want to continue."
            });
          } else {
            return this.setState({
              message: "If you proceed, the bundle will be deleted from Purchase Engine. Are you sure you want to continue?",
              disableDeleteAction: false
            });
          }
        case "licenseBundles":
          if (!isEmpty(resource.productLicenseBundles) || !isEmpty(resource.templatesLicenseBundles)) {
            return this.setState({
              message:
                "There are templates / subscriptions / purchases / invoices that contain this license bundle. Delete those records first, if you want to continue."
            });
          } else {
            return this.setState({
              message:
                "If you proceed, the license bundle will be deleted from Purchase Engine. Are you sure you want to continue?",
              disableDeleteAction: false
            });
          }
        case "productMetadataTypes":
          if (!isEmpty(resource.productMetadataItems) || !isEmpty(resource.templatesFeatures)) {
            return this.setState({
              message:
                "There are templates or subscriptions that contain this feature. Delete those records first, if you want to continue."
            });
          } else {
            return this.setState({
              message:
                "If you proceed, the feature will be deleted from Purchase Engine. Are you sure you want to continue?",
              disableDeleteAction: false
            });
          }
        case "productGroups":
          if (!isEmpty(resource.discounts)) {
            return this.setState({
              message: "There are discounts assigned to this product group. Delete those first."
            });
          } else if (!isEmpty(resource.productGroupings)) {
            return this.setState({
              message:
                "There are subscriptions assigned to this product group. Update those subscriptions and then try again."
            });
          } else {
            return this.setState({
              message:
                "If you proceed, the product group will be deleted from Purchase Engine. Are you sure you want to continue?",
              disableDeleteAction: false
            });
          }
        case "invoices":
          return this.setState({
            message: "If you proceed, the invoice will be deleted from Purchase Engine. Are you sure you want to continue?"
          });
        case "templates":
          return this.setState({
            message: "Are you sure you want to delete the template ?",
            disableDeleteAction: false
          });
        case "discounts":
          return this.setState({
            message: "Are you sure you want to delete this discount?",
            disableDeleteAction: false
          });
        default:
          return this.setState({ message: "Unpermited action!" });
      }
    }
  };

  render() {
    const expirePurchases = this.state.expirePurchases;

    let buttonExpirePurchase;
    if (expirePurchases) {
      buttonExpirePurchase = (
        <Button
          style={{ backgroundColor: "#f9fafb" }}
          className="text orange"
          content="Yes"
          type="submit"
          disabled={this.state.disableDeleteAction}
          onClick={() => this.expirePurchase(this.props.resource)}
          data-test="confirm_delete"
        />
      );
    } else {
      buttonExpirePurchase = (
        <Button
          style={{ backgroundColor: "#f9fafb" }}
          className="text orange"
          content="Confirm Delete"
          type="submit"
          disabled={this.state.disableDeleteAction}
          onClick={this.confirmDelete}
          data-test="confirm_delete"
        />
      );
    }
    return (
      <Fragment>
        <Modal
          trigger={
            <Label
              color="orange"
              size="large"
              basic
              style={{ border: "none", cursor: "pointer", padding: 0 }}
              onClick={this.handleOpen}
              data-test={`delete-${this.state.resourceName}`}
            >
              <Icon name="trash alternate outline" />
              Delete
            </Label>
          }
          open={this.state.modalOpen}
          size="small"
          data-test="delete_modal"
        >
          <Header>
            <h1 data-test="modal_title">{`Delete record ${this.state.recordName}!`}</h1>
          </Header>
          <Modal.Content data-test="modal_message">{this.state.message}</Modal.Content>
          <Modal.Actions>
            <Button
              size="medium"
              color="orange"
              content="Cancel"
              type="button"
              onClick={this.handleCancel}
              data-test="cancel_delete"
            />
            {buttonExpirePurchase}
          </Modal.Actions>
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  resource: build(get(state, "deleteSummary.resources", {}), ownProps.resourceName, ownProps.recordSlug, {
    ignoreLinks: true
  })
});

export default connect(mapStateToProps)(DeleteModal);
